import { useState } from "react";

const Switch = ({
  toggle = false,
  setToggle,
  className,
  onClick = () => {},
}) => {
  const toggleClass = " transform translate-x-5";
  return (
    //   Switch Container
    <div
      className={
        "md:w-13 md:h-6 w-12 h-6 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer " +
        className +
        (toggle ? " bg-theme-primary" : "")
      }
      onClick={() => {
        if (setToggle) {
          setToggle(!toggle);
        }
        if (onClick) {
          onClick();
        }
      }}>
      <div
        className={
          "bg-white md:w-5 md:h-5 h-5 w-5 rounded-full shadow-md transform" +
          (toggle ? toggleClass : null)
        }></div>
    </div>
  );
};

export default Switch;
